/**
 * Created by rastwe on 3/1/2017.
 * Traditionally, the root reducer file is named index.js
 *
 * This rootReducer config object is passed to Redux.createStore() in
 * configurestore.{env}.js.
 */
import {combineReducers} from 'redux';
import {default as navReducer} from '../common/components/Nav/NavActions';
import {default as adminReducer} from '../features/admin/admin';
import {default as errorReducer} from '../common/errors';
import {default as userReducer} from '../features/users/users';
import {default as projectReducer} from '../features/projects/projects';
import {default as versionUpdateReducer} from '../features/version-update/version-update';
import {default as projectSummaryReducer} from '../features/projectSummary/projectSummary';
import {default as projectFinancialFilterReducer} from '../features/projectSummary/components/FinancialDetails/projectFinancialFilterReducer';
import {default as paansReducer} from '../features/paans/paans';
import {loadingReducer} from '../common/loading';
import modalOpenStateReducer from '../common/setIsModalOpen';
import {independenceSlice} from '../features/projectSummary/components/Independence/Store/Slice';
import {projectPayload} from '../features/projects/components/wizard/Store/Slice';

/* All of the application's reducers will be combined into this
 * rootReducer. Be careful of what you name these objects! The names
 * you choose will be referred to through the state object every
 * time you access it. So, "languages" below will end up being referred
 * to as state.languages.
 * Also note that we're using the ES6 shorthand property name here
 * for "languages: languages".
 *
 * All combineReducers() does is generate a function that calls your
 * reducers with slices of state according to their keys.
 * Ref: http://redux.js.org/docs/api/combineReducers.html
 */
const rootReducer = combineReducers({
	admin: adminReducer,
	errors: errorReducer,
	user: userReducer,
	projects: projectReducer,
	projectSummary: projectSummaryReducer,
	filters: projectFinancialFilterReducer,
	loading: loadingReducer,
	isModalOpen: modalOpenStateReducer,
	nav: navReducer,
	appVersion: versionUpdateReducer,
	independence: independenceSlice.reducer,
	projectPayload: projectPayload.reducer,
	paansuserdata: paansReducer
});

export default rootReducer;
